// @flow
export const ORDER_TYPE_NEW_CARD_WITH_PRODUCT = 'NEW_CARD_WITH_PRODUCT'
export const ORDER_TYPE_NEW_CARD = 'NEW_CARD'
export const ORDER_TYPE_REPLACE_CARD = 'REPLACE_CARD'
export const ORDER_TYPE_REPLACE_CARD_WITH_PRODUCT = 'REPLACE_CARD_WITH_PRODUCT'
export const ORDER_TYPE_TERMINATE_CARD = 'TERMINATE_CARD'
export type OrderType = 'NEW_CARD_WITH_PRODUCT' | 'NEW_CARD' | 'REPLACE_CARD' | 'REPLACE_CARD_WITH_PRODUCT' | 'TERMINATE_CARD'



// WEBPACK FOOTER //
// ./src/types/order-type.js